import { Drawer } from '../Drawer';
import { ChangePassword, Preferences, Logout, Icons } from './DrawerSections';

import { useAuth } from 'views/Login/Auth';
import { useNavigate } from 'react-router';
import { RouteValue } from 'types';

import { useMutation } from '@apollo/client';
import { Mutation, UserProfile, UserPreferencesInput } from '../../generated/graphql';
import { USER_PREFERENCES } from '../../apollo-client/mutations/setUserPreferences';

import { EuiComboBoxOptionOption } from '@elastic/eui';
import { defaultRegions } from 'cache';
import { useLocalCache } from 'hooks/useLocalCache';

interface UserProfileDrawerProps {
  isActive: boolean;
  onClose: () => void;
  userPreferences?: { userProfile: UserProfile };
}

export const UserProfileDrawer = ({ isActive, onClose, userPreferences }: UserProfileDrawerProps): JSX.Element => {
  const [setUserPreferences, { data, loading }] = useMutation<Mutation, UserPreferencesInput>(USER_PREFERENCES);

  const auth = useAuth();
  const history = useNavigate();
  const onRouteChange = (route: RouteValue): void => history(route);
  const localFilters = useLocalCache();

  const handleSave = (): void => {
    !loading &&
      setUserPreferences({
        variables: {
          defaultRegions: localFilters?.data?.defaultRegions,
        },
      });
  };

  const handleClose = (): void => {
    onClose();
    defaultRegions(data?.setUserPreferences?.regions || userPreferences?.userProfile?.preferences?.regions);
  };

  return (
    //TODO use dynamic Drawer
    <Drawer isActive={isActive} onClose={handleClose}>
      <ChangePassword />
      <Preferences
        regions={localFilters?.data?.defaultRegions?.map((x: string) => ({ label: x, value: x }))}
        onChangeRegions={(x: EuiComboBoxOptionOption<string>[]): string[] | undefined =>
          defaultRegions(x?.map(({ value }) => value) as string[])
        }
        onSave={handleSave}
        isLoading={loading}
      />
      <Icons />
      <Logout onClick={(): void => auth.signout(onRouteChange)} />
    </Drawer>
  );
};
